import * as React from 'react';

export const ecFlagContent: JSX.Element = (
    <>
        <g clip-path='url(#clip0_55_3145)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#FECA00'
            />
            <mask
                id='mask0_55_3145'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_55_3145)'>
                <path
                    d='M0 13.3333H28V20H0V13.3333Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#E31D1C'
                />
                <path
                    d='M0 0H28V6.66667H0V0Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#5EAA22'
                />
                <path
                    d='M14 15C16.7614 15 19 12.7614 19 10C19 7.23858 16.7614 5 14 5C11.2386 5 9 7.23858 9 10C9 12.7614 11.2386 15 14 15Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#2B77B8'
                />
                <path
                    d='M14 11.6667L11.6983 12.4388L12.4149 10.515L10.8537 8.65163H13.0203L14 6.66666L14.9796 8.65163H17.194L15.5851 10.515L16.1562 12.4388L14 11.6667Z'
                    stroke-width='1.25'
                    stroke='#FECA00'
                />
                <path
                    d='M13.7468 10.0287L12.0096 13.6622'
                    stroke-width='0.833333'
                    stroke='#2B77B8'
                />
                <path
                    d='M13.4734 9.56617H10.1401'
                    stroke-width='0.833333'
                    stroke='#2B77B8'
                />
                <path
                    d='M14.1012 10.698L17.3587 12.2015'
                    stroke-width='0.833333'
                    stroke='#2B77B8'
                />
                <path
                    d='M14.8055 9.89474L17.1635 7.31375'
                    stroke-width='0.833333'
                    stroke='#2B77B8'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_55_3145'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
